(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { isInteger } from '../../utils/number.js';
var n1 = 'number';
var n2 = 'number, number';
export function bitAndNumber(x, y) {
  if (!isInteger(x) || !isInteger(y)) {
    throw new Error('Integers expected in function bitAnd');
  }

  return x & y;
}
bitAndNumber.signature = n2;
export function bitNotNumber(x) {
  if (!isInteger(x)) {
    throw new Error('Integer expected in function bitNot');
  }

  return ~x;
}
bitNotNumber.signature = n1;
export function bitOrNumber(x, y) {
  if (!isInteger(x) || !isInteger(y)) {
    throw new Error('Integers expected in function bitOr');
  }

  return x | y;
}
bitOrNumber.signature = n2;
export function bitXorNumber(x, y) {
  if (!isInteger(x) || !isInteger(y)) {
    throw new Error('Integers expected in function bitXor');
  }

  return x ^ y;
}
bitXorNumber.signature = n2;
export function leftShiftNumber(x, y) {
  if (!isInteger(x) || !isInteger(y)) {
    throw new Error('Integers expected in function leftShift');
  }

  return x << y;
}
leftShiftNumber.signature = n2;
export function rightArithShiftNumber(x, y) {
  if (!isInteger(x) || !isInteger(y)) {
    throw new Error('Integers expected in function rightArithShift');
  }

  return x >> y;
}
rightArithShiftNumber.signature = n2;
export function rightLogShiftNumber(x, y) {
  if (!isInteger(x) || !isInteger(y)) {
    throw new Error('Integers expected in function rightLogShift');
  }

  return x >>> y;
}
rightLogShiftNumber.signature = n2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(n1, "n1", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(n2, "n2", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(bitAndNumber, "bitAndNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(bitNotNumber, "bitNotNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(bitOrNumber, "bitOrNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(bitXorNumber, "bitXorNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(leftShiftNumber, "leftShiftNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(rightArithShiftNumber, "rightArithShiftNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
  reactHotLoader.register(rightLogShiftNumber, "rightLogShiftNumber", "/home/yatham/Dev_BHS_Portal/node_modules/mathjs/lib/esm/plain/number/bitwise.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();